<template>
  <div>
    <div class="separator-big"></div>
    <div class="title">Terms of Use</div>
    <div class="separator-small"></div>

    <div class="container">
      <span>Last Update: 02.10.2025</span>
    </div>

    <div class="container">
      <div class="separator-big"></div>
      <div class="sub-title">Our Apps &amp; Games</div>
      <div class="separator-small"></div>

      <div class="content">
        <p>
          By downloading or using our apps &amp; games (“App”), you agree to these Terms of Use.
          If you do not agree, please do not use the App.
        </p>

        <div class="separator-big"></div>
        <p class="sub-title-bold">License &amp; Eligibility</p>
        <div class="separator-xs"></div>
        <p>
          We grant you a limited, non-exclusive, non-transferable, revocable license to use the
          App for personal, non-commercial purposes. You must be of legal age in your jurisdiction
          (or have parental consent) to use the App.
        </p>

        <div class="separator-big"></div>
        <p class="sub-title-bold">Subscriptions &amp; Billing</p>
        <div class="separator-xs"></div>
        <p>
          Some features are offered via auto-renewing subscriptions. Payment is handled by Apple
          using your Apple ID. Subscriptions renew unless canceled at least 24 hours before the
          current period ends. You can manage or cancel in
          <i>Settings &gt; Apple ID &gt; Subscriptions</i>. Trials (if offered) convert to paid
          unless canceled before they end. Refunds, if any, are handled by Apple per App Store policy.
        </p>

        <div class="separator-big"></div>
        <p class="sub-title-bold">In-App Purchases</p>
        <div class="separator-xs"></div>
        <p>
          Some content or features may be offered as one-time purchases. Delivery occurs after
          Apple confirms payment. All sales are final except where required by law or App Store policy.
        </p>

        <div class="separator-big"></div>
        <p class="sub-title-bold">User Content</p>
        <div class="separator-xs"></div>
        <p>
          You retain ownership of content you import or create. You are responsible for having the
          necessary rights to use such content in the App and for ensuring it does not infringe
          others’ rights or applicable laws.
        </p>

        <div class="separator-big"></div>
        <p class="sub-title-bold">Acceptable Use</p>
        <div class="separator-xs"></div>
        <p>
          Do not use the App for unlawful, harmful, or infringing activity. Do not attempt to
          reverse engineer, interfere with, or disrupt the App or related services.
        </p>

        <div class="separator-big"></div>
        <p class="sub-title-bold">Intellectual Property</p>
        <div class="separator-xs"></div>
        <p>
          The App and all associated materials are protected by intellectual property laws.
          Except for the limited license above, no rights are granted to you.
        </p>

        <div class="separator-big"></div>
        <p class="sub-title-bold">Privacy</p>
        <div class="separator-xs"></div>
        <p>
          Your use of the App is subject to our Privacy Policy.
          Please review it to understand how information may be handled by third-party services.
        </p>

        <div class="separator-big"></div>
        <p class="sub-title-bold">Disclaimers</p>
        <div class="separator-xs"></div>
        <p>
          The App is provided “as is” and “as available,” without warranties of any kind, express
          or implied, including merchantability, fitness for a particular purpose, and non-infringement.
        </p>

        <div class="separator-big"></div>
        <p class="sub-title-bold">Limitation of Liability</p>
        <div class="separator-xs"></div>
        <p>
          To the maximum extent permitted by law, we are not liable for indirect, incidental,
          special, consequential, or punitive damages, or any loss of data, profits, or use,
          even if advised of the possibility of such damages.
        </p>

        <div class="separator-big"></div>
        <p class="sub-title-bold">Termination</p>
        <div class="separator-xs"></div>
        <p>
          We may suspend or terminate your access to the App at any time, including for violation
          of these Terms. Upon termination, your license ends immediately.
        </p>

        <div class="separator-big"></div>
        <p class="sub-title-bold">Changes to These Terms</p>
        <div class="separator-xs"></div>
        <p>
          We may update these Terms from time to time. We will update the “Last Update” date above.
          Continued use after changes constitutes acceptance.
        </p>

        <div class="separator-big"></div>
        <p class="sub-title-bold">Governing Law</p>
        <div class="separator-xs"></div>
        <p>
          These Terms are governed by the laws of your jurisdiction, without regard to conflict-of-law rules.
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.container {
  text-align: left;
  padding: 10px 30px;
}
.title {
  font-family: "Roboto Condensed";
  font-size: 50px;
  margin: 0;
}

.sub-title {
  font-family: "Roboto Condensed";
  font-size: 40px;
  margin: 0;
}

.sub-title-bold {
  font-family: "Roboto Condensed";
  font-size: 25px;
  font-weight: bold;
  margin: 0;
}

.content {
  font-family: "Roboto Condensed";
  font-size: 22px;
  margin: 0;
}

.separator {
  &-big {
    height: 30px;
  }
  &-small {
    height: 18px;
  }
  &-xs {
    height: 13px;
  }
}
</style>
